



























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { format } from "date-fns";
import {
  getAllProjectSalesReport,
  getSalesReportCSV,
  getPresets,
  savePreset,
  deletePreset,
  getServiceProjectCompanies,
  GetAllProjectSalesReportQuery
} from "../../api/sales-report-api";
import SalesReportSales from "../components/SalesReportSales.vue";
import SalesReportMonthlyChart from "../components/SalesReportMonthlyChart.vue";
import SalesReportMonthlySummary from "../components/SalesReportMonthlySummary.vue";
import ExpensesGraphSaleReport from "../components/ExpensesGraphSaleReport.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import VIconPrev from "../components/VIconPrev.vue";
import VIconNext from "../components/VIconNext.vue";
import SalesReportSummary from "../components/SalesReportSummary.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { getExpenseCategories } from "@/api/cost/expense-categories-api";
import PresetCreateModal from "@/sales/ui/components/PresetCreateModal.vue";
import PresetDeleteModal from "@/sales/ui/components/PresetDeleteModal.vue";
import YearMonthPicker from "@/components/YearMonthPicker.vue";
import PresetFormData from "@/api/models/PresetFormData";
import IPresetOutput from "@/api/models/IPresetOutput";
import { debounce } from "lodash";
import CustomValueDisplay from "@/common/ui/components/CustomValueDisplay.vue";
import { getConstructionTypesInvitedProject } from "@/api/project/construction-types-api";
import { getAllStaffs } from "@/api/company-api";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import ja from "vue2-datepicker/locale/ja";
import { cloneDeep } from "lodash";

const VALUE_FROM_TO = 0;

interface DateRange {
  year: string;
  month: string;
  show: boolean;
}

@Component({
  components: {
    DatePicker,
    VToolbar,
    VIconPrev,
    VIconNext,
    SalesReportSummary,
    SalesReportMonthlyChart,
    SalesReportMonthlySummary,
    SalesReportSales,
    ExpensesGraphSaleReport,
    PresetCreateModal,
    PresetDeleteModal,
    CustomValueDisplay,
    YearMonthPicker
  }
})
export default class SalesReportAllProjectPage extends Vue {
  jaLocale: any = ja;
  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  companyTypeOptions: SelectOption[] = [
    { text: "全ての事業形態", value: "" },
    { text: "法人", value: "1" },
    { text: "個人", value: "2" },
    { text: "エンドユーザー", value: "3" }
  ];

  // BRV-427
  periodOptions = [
    { value: 1, text: "今期" },
    { value: 2, text: "先月" },
    { value: 3, text: "前期" }
  ];

  period: number = 1;

  staffOptions: SelectOption[] = [{ text: "自社責任者", value: "" }];
  vendorOptions: SelectOption[] = [{ text: "全ての発注先", value: "" }];
  expenseCategoryOptions: SelectOption[] = [{ text: "経費項目", value: "" }];
  presetOptions: SelectOption[] = [{ text: "なし", value: "" }];
  clientOptions: SelectOption[] = [{ text: "全ての発注者", value: "" }];
  constructionTypesOptions: SelectOption[] = [
    { text: "全ての工種", value: "" }
  ];
  presets: IPresetOutput[] = [];
  selectedPresetId = "";

  data = {
    project: null as any,
    estimates: [] as any[],
    purchases: [] as any[],
    invoices: [] as any[],
    performance: {} as any
  };

  report = {} as any;
  monthly = {
    labels: [] as string[],
    invoices: [] as number[],
    purchases: [] as number[],
    profits: [] as number[]
  };

  taxExcluded: boolean = false;
  graphOption = "1";
  graphOptions = [
    { text: "発注金額", value: "1" },
    { text: "利益額", value: "2" },
    { text: "利益率", value: "3" }
  ];
  graphFormatter = 1;
  btnActive: "" | "init" | "next" | "prev" = "init";
  monthRef: {
    data: string[];
    next?: string;
    current: string;
  } = {
    data: [],
    next: undefined,
    current: ""
  };
  query: GetAllProjectSalesReportQuery = {
    month: [],
    companyType: "",
    clientId: "",
    staffId: "",
    vendorId: "",
    expenseCategoryId: "",
    constructionTypeId: "",
    initMonth: ""
  };

  month: Date | undefined;
  monthLabel = "";
  disablePrevMonth = true;
  disableNextMonth: boolean = false;
  isShowIconCalendar: boolean = true;
  isSelectedDateCalendar: boolean = false;
  startDate: string = "";
  endDate: string | undefined = "";

  get settlementMonth() {
    return this.$store.state.service.settlementMonth;
  }

  date: { firstDate: string; lastDate: string | undefined } = {
    firstDate:
      moment().format("M") > this.settlementMonth
        ? moment()
            .month(this.settlementMonth)
            .year(moment().year())
            .startOf("month")
            .format("YYYY-MM-DD")
        : moment()
            .month(this.settlementMonth)
            .year(
              this.settlementMonth === 12
                ? moment().year()
                : moment().year() - 1
            )
            .startOf("month")
            .format("YYYY-MM-DD"),
    lastDate: moment().format("YYYY-MM-DD")
  };

  dateRanges: Array<"start" | "end"> = ["start", "end"];
  selectedDateRange: Record<"start" | "end", DateRange> = {
    start: {
      year: this.getValue(this.date.firstDate)[0],
      month: this.getValue(this.date.firstDate)[1],
      show: false
    },
    end: {
      year: this.getValue(this.date.lastDate)[0],
      month: this.getValue(this.date.lastDate)[1],
      show: false
    }
  };

  dateRange: string[] = Object.values(this.date) as string[];

  protected async created() {
    if (this.$store.state.service) {
      this.updateMonthLabel();
      this.updateMonthRef();
    }
    await this.initConstructionTypeList();
    await this.initClientList();
    await this.initVendorList();
    await this.initStaffList();
    await this.initExpenseCategories();
    await this.initPresets();

    await this.searchGraph();
  }

  search = debounce(async () => {
    await this.searchGraph();
  }, 500);

  private async searchGraph() {
    this.taxExcluded = false;
    this.graphOption = "1";
    const report = await getAllProjectSalesReport(this.query);
    this.report = report;
  }

  async researchClientOptions() {
    await this.initClientList();
    await this.search();
  }

  @Watch("date", { deep: true })
  async onDateChange(value: any) {
    this.dateRange = [value.firstDate, value.lastDate];
    Object.assign(this.date, { ...value });

    await this.search();
  }

  @Watch("btnActive", { immediate: true })
  onBtnActiveChange() {
    if (!this.btnActive) return;
    switch (this.btnActive) {
      case "next":
      case "prev":
        this.updateMonthLabel();
        this.updateMonthRef(this.date.lastDate);
        this.query.initMonth = this.monthRef.data[0];
        break;
      case "init":
        this.updateMonthLabel();
        this.updateMonthRef();
        this.query.initMonth = "";
        this.disablePrevMonth = true;
        this.disableNextMonth = moment(this.date.firstDate).isSame(
          moment(this.date.lastDate),
          "month"
        );
        break;
    }

    this.$nextTick(() => {
      this.btnActive = "";
    });
  }

  movePrevMonth() {
    this.closeBothCalendar();
    if (this.disablePrevMonth) return;
    this.btnActive = "prev";
    this.disableNextMonth = false;
    this.isSelectedDateCalendar = false;
    const date = moment(this.monthRef.current).subtract(1, "month");
    this.date = {
      ...this.date,
      firstDate: date.startOf("month").format("YYYY-MM-DD"),
      lastDate: date.endOf("month").format("YYYY-MM-DD")
    };
    if (date.isBefore(moment(this.monthRef.data[0]), "month")) {
      this.date = {
        ...this.date,
        firstDate: this.monthRef.data[0],
        lastDate: this.monthRef.data[1]
      };
      this.btnActive = "init";
    }
  }

  moveNextMonth() {
    this.closeBothCalendar();
    if (this.disableNextMonth) return;
    this.btnActive = "next";
    this.disablePrevMonth = false;
    this.isSelectedDateCalendar = false;
    const date =
      this.monthRef.next === undefined
        ? moment(this.monthRef.current)
        : moment(this.monthRef.next);
    this.date = {
      ...this.date,
      firstDate: date.startOf("month").format("YYYY-MM-DD"),
      lastDate: date.endOf("month").format("YYYY-MM-DD")
    };

    if (
      this.monthRef.next !== undefined &&
      date.isSame(moment(this.monthRef.data[1]), "month")
    ) {
      this.disableNextMonth = true;
    }
  }

  @Watch("period")
  updateMonth() {
    this.closeBothCalendar();
    if (this.period === VALUE_FROM_TO) return;
    this.btnActive = "init";
    if (this.period === 1) {
      if (moment().format("M") > this.settlementMonth) {
        this.date.firstDate = moment()
          .month(this.settlementMonth)
          .year(moment().year())
          .startOf("month")
          .format("YYYY-MM-DD");
      } else {
        this.date.firstDate = moment()
          .month(this.settlementMonth)
          .year(
            this.settlementMonth === 12 ? moment().year() : moment().year() - 1
          )
          .startOf("month")
          .format("YYYY-MM-DD");
      }
      this.date.lastDate = moment().format("YYYY-MM-DD");
    }

    if (this.period === 2) {
      this.isShowIconCalendar = false;
      (this.date.firstDate = moment()
        .subtract(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD")),
        (this.date.lastDate = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD"));
    } else {
      this.isShowIconCalendar = true;
    }

    if (this.period === 3) {
      let current = "";
      if (moment().format("M") > this.settlementMonth) {
        current = moment()
          .month(this.settlementMonth)
          .year(moment().year())
          .startOf("month")
          .format("YYYY-MM-DD");
      } else {
        current = moment()
          .month(this.settlementMonth)
          .year(
            this.settlementMonth === 12 ? moment().year() : moment().year() - 1
          )
          .startOf("month")
          .format("YYYY-MM-DD");
      }
      const original = new Date(current);

      const minusMonth = new Date(original);
      minusMonth.setMonth(minusMonth.getMonth(), 0);

      const minusYear = new Date(original);
      minusYear.setFullYear(minusYear.getFullYear() - 1);
      this.date.firstDate = minusYear.toISOString().slice(0, 10);
      this.date.lastDate = minusMonth.toISOString().slice(0, 10);
    }

    const indexToRemove = this.periodOptions.findIndex(
      option => option.value === VALUE_FROM_TO
    );
    if (indexToRemove !== -1) {
      this.periodOptions.splice(indexToRemove, 1);
    }
  }

  updateMonthLabel() {
    const { firstDate, lastDate } = this.date;
    const startFormatted = format(new Date(firstDate), "yyyy年MM月");
    const endFormatted = format(new Date(lastDate as string), "yyyy年MM月");

    this.monthLabel = this.generateMonthLabel(startFormatted, endFormatted);
    [this.startDate, this.endDate] = this.monthLabel.split(" ～ ");

    this.updateSelectedDateRange(firstDate, lastDate as string);
    this.query = { ...this.query, month: [firstDate, lastDate as string] };
  }

  generateMonthLabel(startFormatted: string, endFormatted: string) {
    if (this.isSelectedDateCalendar && this.period === VALUE_FROM_TO) {
      return `${startFormatted} ～ ${endFormatted}`;
    }

    if (this.period === 2) return startFormatted;

    const isInitialActive = this.btnActive === "init";
    const hasEndPeriod =
      this.period === 1 ? ` ～ 現時点` : ` ～ ${endFormatted}`;

    return isInitialActive
      ? `${startFormatted}${hasEndPeriod}`
      : startFormatted;
  }

  updateSelectedDateRange(firstDate: string, lastDate: string) {
    const isSameMonth = moment(firstDate, "YYYY-MM-DD").isSame(
      moment(lastDate, "YYYY-MM-DD"),
      "month"
    );

    this.selectedDateRange.start.year = this.getValue(firstDate)[0];
    this.selectedDateRange.start.month = this.getValue(firstDate)[1];

    if (!isSameMonth) {
      this.selectedDateRange.end.year = this.getValue(lastDate)[0];
      this.selectedDateRange.end.month = this.getValue(lastDate)[1];
    }
  }

  updateMonthRef(lastDate?: string) {
    this.monthRef = {
      ...this.monthRef,
      current: this.date.firstDate,
      next: lastDate
        ? moment(this.date.firstDate)
            .add(1, "month")
            .format("YYYY-MM-DD")
        : undefined
    };
    if (!lastDate) {
      this.monthRef.data = [this.date.firstDate, String(this.date.lastDate)];
    }
  }

  private async initClientList() {
    this.query.clientId = "";
    this.clientOptions = [{ text: "全ての発注者", value: "" }];
    const companies = await getServiceProjectCompanies({
      type: "client",
      companyType: this.query.companyType
    });
    companies.map((company: any) =>
      this.clientOptions.push({
        value: company.id,
        text: company.name
      })
    );
  }

  private async initConstructionTypeList() {
    const data = await getConstructionTypesInvitedProject();
    this.constructionTypesOptions = this.constructionTypesOptions.concat(
      data.map((constructionType: any) => ({
        value: constructionType.id,
        text: constructionType.name
      }))
    );
  }

  private async initVendorList() {
    const companies = await getServiceProjectCompanies({
      type: "vendor"
    });
    companies.map((company: any) =>
      this.vendorOptions.push({
        value: company.office.id,
        text: company.name
      })
    );
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get user() {
    return this.$store.state.user;
  }

  get isSuperAdmin(): boolean {
    return this.permissions.includes("service/project_operation");
  }

  private async initStaffList() {
    const staffs = await getAllStaffs({ family: 1 });

    staffs.map((staff: any) => {
      if (this.isSuperAdmin) {
        this.staffOptions.push({
          value: staff.staffId,
          text: staff.name
        });
      } else {
        this.staffOptions.push({
          value: staff.staffId,
          text: staff.name
        });
        if (this.user.staffId == staff.staffId) {
          this.query.staffId = staff.staffId;
        }
      }
    });
  }

  private async initExpenseCategories() {
    const expenseCategories = await getExpenseCategories();
    expenseCategories.map(category => {
      if (category.name !== "値引き") {
        this.expenseCategoryOptions.push({
          value: category.id,
          text: category.name
        });
      }
    });
  }

  private async initPresets() {
    this.presets = await getPresets();
    this.presetOptions = [];
    this.presetOptions.push({ text: "なし", value: "" });
    this.presets.map((preset: any) => {
      this.presetOptions.push({
        value: preset.id,
        text: preset.name
      });
    });
  }

  private resetPreset() {
    this.query.companyType = "";
    this.query.clientId = "";
    this.query.vendorId = "";
    this.query.staffId = "";
    this.query.expenseCategoryId = "";
    this.query.constructionTypeId = "";
  }

  async changePresetOption() {
    if (this.selectedPresetId) {
      const preset = this.presets.find(
        item => item.id === this.selectedPresetId
      );

      if (preset) {
        this.query.companyType = preset.companyType ? preset.companyType : "";
        this.query.clientId = preset.clientId ? preset.clientId : "";
        this.query.vendorId = preset.vendorId ? preset.vendorId : "";
        this.query.staffId = preset.staffId ? preset.staffId : "";
        this.query.constructionTypeId = preset.constructionTypeId
          ? preset.constructionTypeId
          : "";
        this.query.expenseCategoryId = preset.expenseCategoryId
          ? preset.expenseCategoryId
          : "";
      }
    } else {
      this.resetPreset();
    }
    await this.search();
  }

  async createPreset(presetName: string) {
    const form = PresetFormData({
      id: "",
      name: presetName,
      serviceId: this.$store.state.serviceId,
      companyType: this.query.companyType ? this.query.companyType : "",
      clientId: this.query.clientId ? this.query.clientId : "",
      vendorId: this.query.vendorId ? this.query.vendorId : "",
      staffId: this.query.staffId ? this.query.staffId : "",
      constructionTypeId: this.query.constructionTypeId
        ? this.query.constructionTypeId
        : "",
      expenseCategoryId: this.query.expenseCategoryId
        ? this.query.expenseCategoryId
        : ""
    });
    const presetId = await savePreset(form);
    await this.initPresets();
    this.selectedPresetId = presetId;
    alert("保存しました。");
  }

  async deletePreset() {
    if (this.selectedPresetId) {
      await deletePreset(this.selectedPresetId);
      alert("削除されました。");
      this.initPresets();
      this.selectedPresetId = "";
      this.resetPreset();
      await this.search();
    }
  }

  async exportCSV() {
    const response = await getSalesReportCSV({
      ...this.query
    });
    if (response.file) {
      window.open(response.file);
    }
  }

  get reportSummary() {
    if (this.report.summary) {
      return this.taxExcluded
        ? this.report.summary.excludedTax
        : this.report.summary.includedTax;
    }
    return {};
  }

  get expenseCategoriesLabel() {
    if (this.report.expenses) {
      let tempExpenses = this.report.expenses;
      if (this.graphOption === "1") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.orderAmount) !== 0
        );
      }

      if (this.graphOption === "2") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitAmount) !== 0
        );
      }

      if (this.graphOption === "3") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitRate) !== 0
        );
      }

      return tempExpenses.map((item: any) => item.categoryName);
    }
    return [];
  }

  get expenseCategoriesValue() {
    this.graphFormatter = 1;
    if (this.report.expenses) {
      if (this.graphOption === "1") {
        return this.report.expenses
          .filter((item: any) => Number(item.orderAmount) !== 0)
          .map((item: any) => item.orderAmount);
      }

      if (this.graphOption === "2") {
        return this.report.expenses
          .filter((item: any) => Number(item.profitAmount) !== 0)
          .map((item: any) => item.profitAmount);
      }

      if (this.graphOption === "3") {
        this.graphFormatter = 2;
        return this.report.expenses
          .filter((item: any) => Number(item.profitRate) !== 0)
          .map((item: any) => item.profitRate);
      }
    }
    return [];
  }

  get expenseGraphFormatter() {
    return this.graphFormatter;
  }

  showModalCreate() {
    (this.$refs.presetCreateModal as any).show();
  }

  showModalDelete() {
    (this.$refs.presetDeleteModal as any).show();
  }

  isEmptyPieChart() {
    return this.expenseCategoriesValue.every((item: any) => Number(item) === 0);
  }

  toogleCalendarStart() {
    this.selectedDateRange.start.show = !this.selectedDateRange.start.show;
    this.selectedDateRange.end.show = false;
  }

  toogleCalendarEnd() {
    this.selectedDateRange.end.show = !this.selectedDateRange.end.show;
    this.selectedDateRange.start.show = false;
  }

  updateDateRange(value: number, key: string, type: "month" | "year") {
    const tempRange: any = cloneDeep(this.selectedDateRange);
    tempRange[key][type] = value.toString();

    if (this.validateDateFromTo(tempRange)) {
      this.selectedDateRange = tempRange;
      this.isSelectedDateCalendar = true;
      this.hiddenCalendar(key);
      this.updateFirstAndLastDate();
      this.ensurePeriodOptionExists();
      this.updateMonthLabel();
      this.updateMonthRef();
    }
  }

  changedMonth(value: number, key: string) {
    this.updateDateRange(value, key, "month");
  }

  changedYear(value: number, key: string) {
    this.updateDateRange(value, key, "year");
  }

  hiddenCalendar(key: string) {
    if (key == "start") {
      this.selectedDateRange.start.show = false;
    } else {
      this.selectedDateRange.end.show = false;
    }
  }

  getValue(value: string | undefined) {
    if (!value) return ["", "", ""];
    return value.split("-");
  }

  closeBothCalendar() {
    this.selectedDateRange.start.show = false;
    this.selectedDateRange.end.show = false;
  }

  updateFirstAndLastDate() {
    this.date.firstDate =
      this.selectedDateRange.start.year +
      "-" +
      this.selectedDateRange.start.month +
      "-01";
    this.date.lastDate =
      this.selectedDateRange.end.year +
      "-" +
      this.selectedDateRange.end.month +
      "-01";
  }

  validateDateFromTo(tempRange: any) {
    const { start, end } = tempRange;
    if (
      start.year > end.year ||
      (start.year === end.year && start.month > +end.month)
    ) {
      alert("日付指定が不正です。");

      return false;
    }

    return true;
  }

  ensurePeriodOptionExists() {
    const indexToRemove = this.periodOptions.findIndex(
      option => option.value === VALUE_FROM_TO
    );

    if (indexToRemove === -1) {
      this.periodOptions.push({
        text: "From-To",
        value: VALUE_FROM_TO
      });
    }

    this.period = VALUE_FROM_TO;
  }

  handleClickOutside(event: Event) {
    const classes = (event.target as HTMLElement).classList;
    if (
      classes.contains("calendar-settlement_month_start") &&
      ((this.$refs["yearMonthPicker_start"] as Vue[])[0].$el as HTMLElement)
        .style.visibility !== "visibility"
    ) {
      return;
    }

    if (
      classes.contains("calendar-settlement_month_end") &&
      ((this.$refs["yearMonthPicker_end"] as Vue[])[0].$el as HTMLElement).style
        .visibility !== "visibility"
    ) {
      return;
    }
    this.closeBothCalendar();
  }
}
